
import { defineComponent, PropType, ref } from 'vue'
import { User } from '@/types/user'
export default defineComponent({
  name: 'MasterFormModal',

  props: {
    user: {
      type: Object as PropType<User>,
      required: true,
    },
    removeDeletedUser: {
      type: Function as PropType<(uuid: string) => Promise<null>>,
      required: true,
    },
  },

  emits: ['close'],

  setup(props, { emit }) {
    const loading = ref(false)

    function close() {
      emit('close')
    }

    async function confirm() {
      loading.value = true
      await props.removeDeletedUser(props.user.uuid)
      loading.value = false
      close()
    }

    return { close, confirm, loading }
  },
})
